<div class="flex flex-col gap-6">
	<h2>Seguridad</h2>

	<div class="flex items-center gap-3">
		<activar-switch [checked]="false" [disabled]="true" [ariaLabel]="'Autenticación en dos pasos'" />
		<span>Autenticación en dos pasos — próximamente</span>
	</div>
</div>
